import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import LogoIcon from '@/assets/icons/Logo.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import {
  MaintenanceContentStyles,
  MaintenanceIconStyles,
  MaintenanceLogoStyles,
  MaintenanceMessageStyles,
  MaintenancePanelStyles,
  MaintenanceRootStyles,
  MaintenanceTextStyles,
  MaintenanceTitleStyles,
} from '@/views/maintenance/Maintenance.styles.ts';

export const MaintenanceView: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.maintenance');

  return (
    <Box sx={MaintenanceRootStyles}>
      <Stack aria-live="polite" component="main" role="status" sx={MaintenancePanelStyles}>
        <Box sx={MaintenanceLogoStyles}>
          <LogoIcon sx={{ height: '100%', width: '100%' }} />
        </Box>
        <Box sx={MaintenanceContentStyles}>
          <Box aria-hidden="true" sx={MaintenanceIconStyles}>
            <BuildOutlinedIcon />
          </Box>
          <Box sx={MaintenanceTextStyles}>
            <Typography component="h1" sx={MaintenanceTitleStyles}>
              {t('title')}
            </Typography>
            <Typography sx={MaintenanceMessageStyles}>{t('message')}</Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};
